// An empty check is consumed only inside its editor. Fresh autosaves in this
// mount are not abandoned work; a refresh creates a new recovery session.
export function consumeEmptyEditorRecoveryCheck(checkedKeys, key, draftRecord, editorAllowed) {
  if (!key || draftRecord || !editorAllowed) return false;
  checkedKeys.add(key);
  return true;
}

// The envelope owns the existing document identity; quoteNo is display data, not a save target.
export function resolveGeneralDraftEditingIdentity(record, workspaceUid) {
  if (record?.workspaceUid && record.workspaceUid !== workspaceUid) return { error: true };
  const data = record?.data || {};
  const ids = [record?.entityId, data.editingQuoteId, data.quoteId]
    .filter(value => value != null && value !== '' && value !== 'new');
  if (ids.some(value => typeof value !== 'string' || value !== value.trim() || value.length > 180 || /[\/\\\x00-\x1f]/.test(value) || ['.', '..'].includes(value))) return { error: true };
  if (new Set(ids).size > 1) return { error: true };
  return { quoteId: ids[0] || '', error: false };
}
